import { useEffect } from 'react'
import ClientContactActions from '@ClientActions/contact.action'
import * as Redux from 'redux'
import { connect } from 'react-redux'
import { ICommonQuery } from '@Models/common.model'
import { MContactMessage } from '@Models/client/contact.model'
import { APIServices } from '@Services/api.service'

// models section
interface IMessageList {
    messages: MContactMessage[]
}
const MessageList = ({ messages }: IMessageList) => {
    return (
        <>
            {messages?.length ? (
                messages?.map((message: MContactMessage, index: number) => {
                    return (
                        <div
                            className="text-content-box page-border-bottom py-2"
                            key={`${message?.id}_message_${+index}`}
                        >
                            <p className="black-text m-0">{message?.title}</p>
                            <span
                                style={{ marginTop: '-3px' }}
                                className="d-block gray-text"
                            >
                                {message?.madeAt} - {message?.madeAt}
                            </span>
                            <img
                                style={{
                                    position: 'absolute',
                                    right: 0,
                                    top: '40%',
                                }}
                                src={
                                    require('@Images/icons/right-arrow.svg')
                                        .default
                                }
                                alt=""
                                className="cursor-pointer"
                            />
                        </div>
                    )
                })
            ) : (
                <div className="text-center">No data</div>
            )}
        </>
    )
}

// models section
interface IMessagesCenter {
    // redux
    getMessages?: (params?: ICommonQuery) => void
    messages?: MContactMessage[]
}
function MessagesCenter(props: IMessagesCenter) {
    // core section
    const { getMessages, messages } = props

    // hooks section
    useEffect(() => {
        if (getMessages) getMessages()
        return () => {
            APIServices.axiosCancelToken()
        }
    }, [])

    return (
        <div className="page-white-card">
            <div className="p-3" style={{ minHeight: '35vh' }}>
                <p className="black-text m-0 pb-2 page-border-bottom">
                    Message Center
                </p>
                <MessageList messages={messages || []} />
            </div>
        </div>
    )
}

// store section
const mapStateToProps = (store: any) => {
    const { messages } = store?.client?.contacts
    return { messages }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getMessages } = ClientContactActions
    return {
        getMessages: (params?: ICommonQuery) =>
            dispatch(getMessages(params) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MessagesCenter)
